import React from 'react'

const ApprovalMechanism = () => {
  return (
    <div>
      ApprovalMechanism
    </div>
  )
}

export default ApprovalMechanism
